import { Action } from '@ngrx/store';
import { Order, OrderUL, OrderULResponse } from '@cemex-core/cmx-api/models/order-management/order';
import { IRepeatOrderValidationRequest } from '@cemex-core/cmx-api/models/repeat-order-validation/repeat-order-validation-req';
import { IRepeatOrderValidationResponse } from '@cemex-core/cmx-api/models/repeat-order-validation/repeat-order-validation-res';
import { CreateDraftRequest } from '@cemex-core/cmx-api/models/drafts/requests/create-draft-request';
import { CreateDraftResponse } from '@cemex-core/cmx-api/models/drafts/responses/create-draft-response';
import { PatchOrderRequestedResponse, UpdatePatchResponse } from '@cemex-core/cmx-api';
import { ORDER_EXPERIENCES } from '@ordersnproducts/modules/shared/constants/order-experiences';

export enum RepeatOrderActionTypes {
  LOAD = '[RepeatOrder] Load repeat-order detail',
  LOAD_SUCCESS = '[RepeatOrder] Load repeat-order detail success',
  LOAD_FAIL = '[RepeatOrder] Load repeat-order detail failed',
  TOGGLE_LOADER = '[RepeatOrder] toggle loader',

  ATTEMPT_TO_CREATE_ORDER = '[RepeatOrder] attempt to create order',

  REPEAT_ORDER_CREATE_DRAFT_SUCCESS = '[RepeatOrder] create draft success',
  REPEAT_ORDER_CREATE_DRAFT_FAILED = '[RepeatOrder] create draft failed',

  REPEAT_ORDER_CREATE_ORDER_SUCCESS = '[RepeatOrder] create order success',
  REPEAT_ORDER_CREATE_ORDER_FAILED = '[RepeatOrder] create order failed',

  /* Repeat order validation */
  VALIDATE_REPEAT_ORDER = '[RepeatOrder] validate',
  REPEAT_ORDER_VALIDATION_RESPONSE = '[RepeatOrder] validatation response',
  RESET = '[RepeatOrder] Reset'
}

export class RepeatOrderDetailLoad implements Action {
  readonly type = RepeatOrderActionTypes.LOAD;

  constructor(
    public payload: {
      orderId: number;
      orderTypeCode: string;
      businessLine: string;
    },
  ) {}
}

export class RepeatOrderDetailLoadSuccess implements Action {
  readonly type = RepeatOrderActionTypes.LOAD_SUCCESS;

  constructor(public payload: Order) {}
}

export class RepeatOrderDetailLoadFail implements Action {
  readonly type = RepeatOrderActionTypes.LOAD_FAIL;

  constructor(public payload: any) {}
}

export class RepeatOrderToggleLoader implements Action {
  readonly type = RepeatOrderActionTypes.TOGGLE_LOADER;

  constructor(public payload: boolean) {}
}

export class ValidateRepeatOrder implements Action {
  readonly type = RepeatOrderActionTypes.VALIDATE_REPEAT_ORDER;

  constructor(
    public payload: {
      orderId: number;
      validationRequest: IRepeatOrderValidationRequest;
      experienceCode?: ORDER_EXPERIENCES;
    },
  ) {}
}

export class RepeatOrderValidationResponse implements Action {
  readonly type = RepeatOrderActionTypes.REPEAT_ORDER_VALIDATION_RESPONSE;

  constructor(public payload: IRepeatOrderValidationResponse) {}
}

export class RepeatOrderAttemptToCreateOrder implements Action {
  readonly type = RepeatOrderActionTypes.ATTEMPT_TO_CREATE_ORDER;

  constructor(public payload: { order: CreateDraftRequest | OrderUL; experience?: ORDER_EXPERIENCES }) {}
}

export class RepeatOrderDraftRequestSuccess implements Action {
  readonly type = RepeatOrderActionTypes.REPEAT_ORDER_CREATE_DRAFT_SUCCESS;

  constructor(public payload: CreateDraftResponse | OrderULResponse) {}
}

export class RepeatOrderDraftRequestFail implements Action {
  readonly type = RepeatOrderActionTypes.REPEAT_ORDER_CREATE_DRAFT_FAILED;

  constructor(public payload: any) {}
}

export class RepeatOrderRequestSuccess implements Action {
  readonly type = RepeatOrderActionTypes.REPEAT_ORDER_CREATE_ORDER_SUCCESS;

  constructor(
    public payload: { order: UpdatePatchResponse | PatchOrderRequestedResponse; experience?: ORDER_EXPERIENCES },
  ) {}
}

export class RepeatOrderRequestFail implements Action {
  readonly type = RepeatOrderActionTypes.REPEAT_ORDER_CREATE_ORDER_FAILED;

  constructor(public payload: any) {}
}

export class RepeatOrderReset implements Action {
  readonly type = RepeatOrderActionTypes.RESET;

  constructor() {}
}

export type RepeatOrderActions =
  | RepeatOrderDetailLoad
  | RepeatOrderDetailLoadSuccess
  | RepeatOrderDetailLoadFail
  | RepeatOrderToggleLoader
  | ValidateRepeatOrder
  | RepeatOrderValidationResponse
  | RepeatOrderAttemptToCreateOrder
  | RepeatOrderDraftRequestSuccess
  | RepeatOrderDraftRequestFail
  | RepeatOrderRequestSuccess
  | RepeatOrderRequestFail
  | RepeatOrderReset;
